import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ProductImage, ProductVideo} from '@kion/data-models';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {
  CarouselImage,
  CarouselItem,
  CarouselVideo
} from '../../../../../../../shared/ui/src/lib/shared/elements/image-carousel/image-carousel.component';

@Component({
  selector: 'kion-product-carousel',
  templateUrl: './product-carousel.component.html',
  styleUrls: ['./product-carousel.component.scss']
})
export class ProductCarouselComponent implements OnChanges {

  @Input() images: ProductImage[];
  @Input() videos: ProductVideo[];
  carouselImages: CarouselImage[];
  carouselVideos: CarouselVideo[];
  carouselItems: CarouselItem[];

  activeSlide = 0;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.images) {
      if (changes.images.previousValue !== changes.images.currentValue) {
        this.images = changes.images.currentValue;
        this.carouselImages = this.images.map(
          image => {
            return {
              type:"image",
              id: Math.random(),
              url: {
                lazyLoad: image.url + '?width=734&height=790&padColor=fff',
                default: image.url + '?width=50&height=50&padColor=fff',
                error: './assets/ui/shared/error/not_found_error_image.png'
              },
              altText: image.altText,
              titleText: image.titleText || image.altText
            }
          }
        )
        this.carouselItems=this.carouselImages
        if (this.videos) {
          this.carouselVideos = this.videos.map(
            video => {
              return {
                type:"video",
                id: video.videoId,
                quality: video.quality,
                startSeconds: video.startSeconds,
                endSeconds: video.endSeconds
              }
            }
          )
          //add thumbnail for navigation
          this.carouselImages = this.carouselImages.concat(this.videos.map(
            video => {
              return {
                type:"image",
                id: Math.random(),
                url: {
                  lazyLoad: video.url + '?width=734&height=790&padColor=fff',
                  default: video.url + '?width=50&height=50&padColor=fff',
                  error: './assets/ui/shared/error/not_found_error_image.png'
                },
                altText: video.altText,
                titleText: video.titleText || video.altText
              }
            }
          ))
          this.carouselItems = this.carouselItems.concat(this.carouselVideos)
        }
      }

    }
  }

  updateSlide(activeSlide: number) {
    console.log("carusel activ element ",activeSlide)
    this.activeSlide = activeSlide;
  }
}
